import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

const statusStyle: Record<string, string> = {
  发酵中: "bg-primary-100 text-primary-700",
  已核实: "bg-accent-100 text-accent-800",
  待补充: "bg-secondary-100 text-secondary-700",
};

type ArticleCardProps = {
  article: Article;
  index?: number;
};

export default function ArticleCard({ article, index }: ArticleCardProps) {
  return (
    <article className="group h-full bg-background-50 border border-background-200/80 rounded-lg overflow-hidden flex flex-col transition-colors hover:border-primary-300">
      <Link to={`/article/${article.id}`} className="block relative w-full h-48 overflow-hidden">
        <img
          src={article.cover}
          alt={`${article.title} - ${article.category}爆料`}
          title={`${article.title} 511爆料`}
          className="w-full h-48 object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-50/95 text-xs font-medium text-foreground-800 flex items-center gap-1">
          <i className="ri-price-tag-3-line text-primary-500"></i>
          {article.category}
        </span>
        {typeof index === "number" && (
          <span className="absolute top-3 right-3 w-8 h-8 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold">
            {index + 1}
          </span>
        )}
      </Link>

      <div className="p-4 md:p-5 flex flex-col flex-1">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span className={`px-2 py-0.5 rounded-md font-medium ${statusStyle[article.status]}`}>
            {article.status}
          </span>
          <span>{article.date}</span>
        </div>
        <h3 className="mt-3 font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug">
          <Link to={`/article/${article.id}`} className="hover:text-primary-600 transition-colors">
            {article.title}
          </Link>
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3">
          {article.excerpt}
        </p>

        <div className="mt-auto pt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-fire-line text-primary-500"></i>
            </span>
            {article.heat.toLocaleString()} 热度
          </span>
          <span className="flex items-center gap-1">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-eye-line"></i>
            </span>
            {article.views.toLocaleString()}
          </span>
          <span className="flex items-center gap-1">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-chat-3-line"></i>
            </span>
            {article.comments}
          </span>
        </div>
      </div>
    </article>
  );
}